export default {"src":"/_next/static/media/img_linkedin_4_2.db1e9fde.svg","height":614,"width":1440,"blurWidth":0,"blurHeight":0};